import React from "react";

/**
 * FastPrototype.ai brand logo.
 *
 *   variant="mark"      → small SVG chevron mark only (default; ideal for navbar/buttons)
 *   variant="wordmark"  → full SVG wordmark (mark + "fastprototype.ai" text)
 *   variant="image"     → the original full-color PNG (best for downloads / hero)
 *
 * `size` controls height in px.
 */
export default function BrandLogo({ variant = "mark", size = 28, withText = false, className = "" }) {
  if (variant === "image") {
    return (
      <img
        src="/brand/fastprototype-logo.png"
        alt="FastPrototype.ai"
        style={{ height: size, width: "auto" }}
        className={className}
      />
    );
  }
  if (variant === "wordmark") {
    return (
      <img
        src="/brand/fastprototype-wordmark.svg"
        alt="FastPrototype.ai"
        style={{ height: size, width: "auto" }}
        className={className}
      />
    );
  }
  // mark
  if (withText) {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`}>
        <img src="/brand/fastprototype-mark.svg" alt="" style={{ height: size, width: size }} />
        <span className="font-extrabold tracking-tight text-zinc-950">
          fastprototype<span className="bg-gradient-to-r from-emerald-400 to-sky-500 bg-clip-text text-transparent">.ai</span>
        </span>
      </span>
    );
  }
  return (
    <img
      src="/brand/fastprototype-mark.svg"
      alt="FastPrototype.ai"
      style={{ height: size, width: size }}
      className={className}
    />
  );
}
